import React, { Component } from 'react';
import { Layout, Menu } from 'antd';

import Home from './Home';
import AddUser from './addUser/AddUser';
import SearchUser from './searchUser/SearchUser';

const { Header } = Layout;

class LandingPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      currentMenu: 'home',
      selectedComponent: <Home/>
    }
  }

  getComponent = (menu) => {
    let updatedSelectedComponent;

    switch(menu) {
      case 'home':
        updatedSelectedComponent = <Home/>
        break;
      case 'addUser':
        updatedSelectedComponent = <AddUser/>
        break;
      case 'searchUser':
        updatedSelectedComponent = <SearchUser/>
        break;
      default:
        updatedSelectedComponent = null;
    }

    return updatedSelectedComponent;
  }

  onChangeMenu = (menu) => {
    let updatedSelectedComponent = this.getComponent(menu.key);

    this.setState({
      selectedComponent: updatedSelectedComponent,
      currentMenu: menu.key,
    });
  }

  render() {
    const { selectedComponent } = this.state
    return (
      <>
        <Layout>
          <Header>
          <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['home']} >
            <Menu.Item key="home" onClick={this.onChangeMenu}>PHONEBOOK APPLICATION</Menu.Item>
            <Menu.Item key="addUser" onClick={this.onChangeMenu}>Add User</Menu.Item>
            <Menu.Item key="searchUser" onClick={this.onChangeMenu}>Search User</Menu.Item>
          </Menu>
        </Header>
        </Layout>
        {selectedComponent}
      </>
    );
  }
}

export default LandingPage;
